import { render, staticRenderFns } from "./BrandSales.vue?vue&type=template&id=566f9ab0&scoped=true&"
import script from "./BrandSales.vue?vue&type=script&lang=js&"
export * from "./BrandSales.vue?vue&type=script&lang=js&"
import style0 from "./BrandSales.vue?vue&type=style&index=0&id=566f9ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566f9ab0",
  null
  
)

export default component.exports